import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { typedEntries } from "@/types/helpers"
import { TagHierarchy } from "@/types/tag-hierarchy"

export function useListingProfileTagMetadata() {
  const { t } = useTranslation("listing_profile_tags")

  return useMemo(() => {
    const hierarchy = t("tag_categories", {
      returnObjects: true,
    }) as TagHierarchy
    const tags = new Map<string, { name: string; categoryName: string }>()
    typedEntries(hierarchy).forEach(([, category]) => {
      typedEntries(category.tag_subcategories).forEach(([, subcategory]) => {
        typedEntries(subcategory.tags).forEach(([value, tag]) => {
          tags.set(value, { name: tag.name, categoryName: category.name })
        })
      })
    })
    return tags
  }, [t])
}
